<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<p class="ct" id="toc_marker-4"><a href="#/OEBPS/A_Few_Right_Thinking_Men2#Contents-A">Dedication</a></p>
<p class="body-center"><em class="italic">To all the right thinking men I have known,<br class="calibre2"/>and the libertines who keep them in line.</em></p>
<p class="body"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// A_Few_Right_Thinking_Men-3.vue?0c73d6bc